'use client';

import { useEffect } from 'react';
import { usePathname, useRouter } from '@/i18n/routing';
import { useDashboardMode } from '@/context/DashboardContext';
import { isAdminPath } from '@/lib/route-spaces';

/**
 * When user is on an admin-only page and switches ACT from Admin to Private/Org,
 * redirect to dashboard (admin cannot stay on admin pages without admin context).
 */
export function ContextRedirectGuard() {
  const pathname = usePathname();
  const router = useRouter();
  const { isAdminContext } = useDashboardMode();

  useEffect(() => {
    if (isAdminPath(pathname) && !isAdminContext) {
      router.replace('/dashboard');
    }
  }, [pathname, isAdminContext, router]);

  return null;
}
